import React from 'react';
export default function CardInfoField(title, itemValue, className) {
    return (React.createElement("div", { className: `c-medication-or-solution-details-card__default-infos ${className}` },
        React.createElement("span", { className: 'c-medication-or-solution-details-card__default-title' }, title),
        React.createElement("span", { className: 'c-medication-or-solution-details-card__default-text' }, itemValue && itemValue)));
}
//# sourceMappingURL=card-info-field.js.map